<script lang="ts">
  import { Link } from "@inertiajs/svelte";

  let {
    user,
    show,
    onLogout,
  }: {
    user: { id: string; name: string; email: string; avatarUrl?: string };
    show: boolean;
    onLogout: () => void;
  } = $props();

  function setBackground(event: MouseEvent, value: string) {
    (event.currentTarget as HTMLElement).style.background = value;
  }

  function setMenuItemStyle(event: MouseEvent, color: string, background: string) {
    (event.currentTarget as HTMLElement).style.color = color;
    (event.currentTarget as HTMLElement).style.background = background;
  }
</script>

{#if show}
  <div
    class="absolute right-0 mt-2 w-56 rounded-xl py-1 z-50"
    style="background: var(--surface); border: 1px solid var(--border-bright); box-shadow: 0 20px 60px rgba(0,0,0,0.12);"
  >
    <div class="px-4 py-3" style="border-bottom: 1px solid var(--border);">
      <p class="text-sm font-semibold" style="color: var(--text-primary);">{user.name}</p>
      <p class="text-xs mt-0.5" style="color: var(--text-muted);">{user.email}</p>
    </div>

    <Link
      href="/trips?new=true"
      class="flex items-center gap-2 px-4 py-2.5 text-sm font-medium transition-colors duration-150"
      style="color: var(--accent);"
      onmouseenter={(e: MouseEvent) => setBackground(e, 'var(--accent-dim)')}
      onmouseleave={(e: MouseEvent) => setBackground(e, 'transparent')}
    >
      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
      </svg>
      새 여행 만들기
    </Link>

    <div style="border-top: 1px solid var(--border); margin: 4px 0;"></div>

    {#each [
      { href: `/users/${user.id}`, label: '내 프로필', icon: 'M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z' },
      { href: '/trips', label: '내 여행', icon: 'M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z' },
      { href: '/settings', label: '설정', icon: 'M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z M15 12a3 3 0 11-6 0 3 3 0 016 0z' }
    ] as item}
      <Link
        href={item.href}
        class="flex items-center gap-2 px-4 py-2.5 text-sm transition-colors duration-150"
        style="color: var(--text-secondary);"
        onmouseenter={(e: MouseEvent) => setMenuItemStyle(e, 'var(--text-primary)', 'var(--surface-hover)')}
        onmouseleave={(e: MouseEvent) => setMenuItemStyle(e, 'var(--text-secondary)', 'transparent')}
      >
        <svg class="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d={item.icon} />
        </svg>
        {item.label}
      </Link>
    {/each}

    <div style="border-top: 1px solid var(--border); margin: 4px 0;"></div>

    <button
      onclick={onLogout}
      class="flex items-center gap-2 w-full text-left px-4 py-2.5 text-sm transition-colors duration-150 cursor-pointer"
      style="color: #f87171;"
      onmouseenter={(e: MouseEvent) => setBackground(e, 'rgba(239,68,68,0.08)')}
      onmouseleave={(e: MouseEvent) => setBackground(e, 'transparent')}
    >
      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
      </svg>
      로그아웃
    </button>
  </div>
{/if}
